import {
    sendJSONAjax
} from './ajax-requests/sendJSONAjax';

// Function for opening the modal
function openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
        modal.style.display = "flex";
        modal.classList.add('modal--open');
    }
}

// Function to close the modal
function closeModal(modal) {
    if (modal) {
        modal.style.display = "none";
        modal.classList.remove('modal--open');
    }
}

// Button processing for opening modals
document.querySelectorAll('.js-open-modal').forEach((btn) => {
    btn.addEventListener('click', function (e) {
        e.preventDefault();
        const modalId = this.getAttribute('data-href');
        openModal(modalId);
    });
});

// Button processing for closing modals
document.querySelectorAll('.js-modal-close-modal').forEach((btn) => {
    btn.addEventListener('click', function (e) {
        e.preventDefault();
        const modal = this.closest('.modal-item');
        closeModal(modal);
    });
});

let calendlyBtns = document.querySelectorAll('.js-calendly-open')
if (calendlyBtns !== null && calendlyBtns !== undefined) {
    calendlyBtns.forEach((btn) => {
        btn.addEventListener('click', function (e) {
            e.preventDefault()

            if (Calendly !== null && Calendly !== undefined) {
                let popupBackgroundColor = 'f2f2f2'
                let popupHideGDPRBanner = '1'
                let popupTextColor = '000000'
                let popupPrimaryColor = '3dbbff'
                let userId = '';
                let userEmail = '';
                let argsA1 = '';
                let name = '';
                let utm_source = '';

                if (vars !== undefined && vars !== null) {
                    userId = vars.id.trim();
                    userEmail = vars.email.trim();
                    argsA1 = vars.a1.trim();
                    name = vars.name.trim();
                    utm_source = vars.utm_source.trim();
                }

                let urlLink = this.getAttribute('href')

                let urlLinkParams = '?&hide_gdpr_banner=' + popupHideGDPRBanner + '&background_color=' + popupBackgroundColor + '&text_color=' + popupTextColor + '&primary_color=' + popupPrimaryColor + '&id=' + userId + '&email=' + userEmail + '&name=' + name + '&a1=' + argsA1 + '&utm_source=' + utm_source

                let full_link = urlLink + urlLinkParams

                Calendly.initPopupWidget({
                    url: full_link
                });

            }
            return false;
        })
    })
}

let forgotPassForm = document.getElementById('forgotPassForm')
if (forgotPassForm !== null && forgotPassForm !== undefined) {
    forgotPassForm.addEventListener('submit', function (e) {
        e.preventDefault()

        let url = this.getAttribute('action')
        let formData = new FormData(this)

        let invalidFeedbackContainer = this.querySelector('.invalid-feedback')
        invalidFeedbackContainer.style.display = 'none'

        const modal1 = document.getElementById("modal1");
        const modal2 = document.getElementById("modal2");

        let button = this.querySelector('button[type=submit]')
        let buttonTextDefault = button.getAttribute('data-text-default')
        let buttonTextProcessing = button.getAttribute('data-text-processing')
        let buttonTextSuccess = button.getAttribute('data-text-success')
        let buttonTextError = button.getAttribute('data-text-error')

        let requestOptions = {
            method: 'POST',
            body: formData,
            headers: new Headers({
                'accept': 'application/json'
            }),
            redirect: 'follow'
        };

        button.textContent = buttonTextProcessing;
        button.setAttribute('disabled', true)

        fetch(url, requestOptions)
            .then(response => response.text())
            .then((result) => {
                let resp = JSON.parse(result)
                if (resp.status !== undefined && resp.status !== null && resp.status === true) {

                    button.textContent = buttonTextSuccess;

                    if (modal1 !== null) {
                        modal1.style.display = "none";
                    }
                    if (modal2 !== null) {
                        modal2.style.display = "flex";
                    }

                    setTimeout(function () {
                        button.textContent = buttonTextDefault;
                        button.removeAttribute('disabled')
                    }, 3000)

                } else {
                    invalidFeedbackContainer.innerHTML = resp.message
                    invalidFeedbackContainer.style.display = 'block'

                    button.textContent = buttonTextError;

                    setTimeout(function () {
                        button.textContent = buttonTextDefault;
                        button.removeAttribute('disabled')
                    }, 2000)
                }
            })
            .catch((errors) => {
                let resp = JSON.parse(errors)
            });
    })
}

let sendItAgainBtn = document.querySelector('.js-send-it-again')

if (sendItAgainBtn !== null && sendItAgainBtn !== undefined) {
    sendItAgainBtn.addEventListener('click', function (e) {
        e.preventDefault()

        const modal1 = document.getElementById("modal1");
        const modal2 = document.getElementById("modal2");

        if (modal2 !== null) {
            modal2.style.display = "none";
        }

        if (modal1 !== null) {
            modal1.style.display = "flex";
        }
    })
}

let disabledReportBtns = document.querySelectorAll('.report-btn-disabled')
if (disabledReportBtns !== null && disabledReportBtns !== undefined) {
    disabledReportBtns.forEach((disabledReportBtn) => {
        disabledReportBtn.addEventListener('click', function (e) {
            e.preventDefault()
        })
    })
}


async function sendAjax(url, data) {
    let csrf = $('meta[name="csrf-token"]').attr('content')

    let sendData = new FormData();

    if (data !== null && data !== undefined) {
        for (const [key, value] of Object.entries(data)) {
            sendData.append(key, value);
        }
    }
    sendData.append('_token', csrf);

    const headers = new Headers({
        "X-CSRF-Token": csrf,
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
    });

    let requestOptions = {
        headers: headers,
        method: 'POST',
        body: sendData,
        redirect: 'follow'
    };
    const response = await fetch(url, requestOptions);
    const res = await response
    return res.json();
}

async function sendAjaxClose(url) {
    let csrf = $('meta[name="csrf-token"]').attr('content')

    let sendData = new FormData();
    sendData.append('_token', csrf);

    const headers = new Headers({
        "X-CSRF-Token": csrf,
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
    });

    let requestOptions = {
        headers: headers,
        method: 'POST',
        body: sendData,
        redirect: 'follow'
    };
    const response = await fetch(url, requestOptions);
    const res = await response
    return res.json();
}

document.addEventListener('DOMContentLoaded', function (e) {
    let welcomeCloses = document.querySelectorAll('.welcome-message .card__close');

    if (welcomeCloses) {
        welcomeCloses.forEach(close => {
            close.addEventListener('click', function (e) {
                e.preventDefault();

                let box = this.closest('.card__box');
                let url = box.getAttribute('data-url');

                // box.remove();

                sendAjaxClose(url).then(response => {
                    box.remove();
                })
            })
        })
    }

    // actions
    const slider = document.querySelector('.js-slider');

    if (slider !== null && slider !== undefined ) {

        const slider = new Swiper('.js-slider .swiper', {
            navigation: {
                nextEl: '.js-slider .swiper-button-next',
                prevEl: '.js-slider .swiper-button-prev',
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            autoplay: {
                delay: 7000,
            },
        });
    }

    const sliderWrappers = document.querySelectorAll('.js-slider-full');

    if (sliderWrappers && sliderWrappers.length > 0) {
        sliderWrappers.forEach(wrapper => {
            if (wrapper.dataset.swiperInitialized === 'true') return;

            const swiperEl = wrapper.querySelector('.swiper');
            const nextEl = wrapper.querySelector('.swiper-button-next');
            const prevEl = wrapper.querySelector('.swiper-button-prev');
            const paginationEl = wrapper.querySelector('.swiper-pagination');

            if (!swiperEl) return;

            const instance = new Swiper(swiperEl, {
                observer: true,
                observeParents: true,
                watchOverflow: true,
                nested: true,
                speed: 400,
                slidesPerView: 3,
                spaceBetween: 12,
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl,
                },
                pagination: paginationEl ? {
                    el: paginationEl,
                    clickable: true,
                    dynamicBullets: false
                } : undefined,
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: true,
                    pauseOnMouseEnter: true,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1, spaceBetween: 12,
                    },
                    680: {
                        slidesPerView: 1.7, spaceBetween: 12,
                    },
                    1024: {
                        slidesPerView: 2.5, spaceBetween: 12,
                    },
                    1081: {
                        slidesPerView: 3, spaceBetween: 12,
                    },
                    1440: {
                        slidesPerView: 3.2, spaceBetween: 12,
                    },
                    1920: {
                        slidesPerView: 3.4, spaceBetween: 12,
                    },
                    2560: {
                        slidesPerView: 5, spaceBetween: 12,
                }
                }
            });

            wrapper.dataset.swiperInitialized = 'true';
        });
    }
})

function responseAction(response) {

    let templates = response.templates

    let topicsCardsList = $(document).find('.js-topics-cards')
    if (topicsCardsList.length !== 0) {
        if (response.loadMore === true) {
            $(document).find('.js-topics-cards-items').append(templates.cards)

            if (response.currentPage === response.maxPages) {
                $(topicsCardsList).find('.load-block').hide()
            }
        } else {
            $(topicsCardsList).replaceWith(templates.cards)
        }
    }

    let topicsLinksList = $(document).find('.js-topics-links')
    if (topicsLinksList.length !== 0) {
        if (response.loadMore === true) {
            $(document).find('.js-topics-links-items').append(templates.links)

            if (response.currentPage === response.maxPages) {
                $(topicsLinksList).find('.load-block').hide()
            }
        } else {
            $(topicsLinksList).replaceWith(templates.links)
        }
    }

    $('.js-topics-container').attr('data-current-page', response.currentPage)
    $('.js-topics-container').attr('data-max-pages', response.maxPages)
}


$(document).on('click', '.btn-favourites', function (e) {
    e.preventDefault()
    let thisBtn = $(this)

    let topicId = $(thisBtn).attr('data-topic-id')
    let allThisTopicCardBtns = $('.btn-favourites[data-topic-id=' + topicId + ']')

    let sendObj = {
        topic_id: topicId,
    }

    if ($(thisBtn).hasClass('btn-favourites--active')) {
        sendObj.adding = 0
    } else {
        sendObj.adding = 1
    }

    console.log(sendObj)

    let url = '/topic-bookmark'

    sendAjax(url, sendObj).then(response => {
        $(allThisTopicCardBtns).toggleClass('btn-favourites--active')
    })
});


const checkboxes = document.querySelectorAll('.js-action-completed');

if (checkboxes && checkboxes.length > 0) {
    checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', function () {
            const form = checkbox.closest('.js-milestones-form');
            const workSpaseDataUrl = form.getAttribute('data-url-work-spase');
            const url = checkbox.getAttribute('data-url');
            const img = checkbox.parentElement.querySelector('img');
            const imgSrcFill = img.getAttribute('data-src-fill');
            const imgSrcEmpty = img.getAttribute('data-src-empty');

            sendJSONAjax(url, null, 'POST').then(response => {
                if (response.errors) {
                    console.error('Error:', response.errors);
                    return;
                }

                sendJSONAjax(workSpaseDataUrl, null, 'GET').then(milestoneDataRes => {
                    if (milestoneDataRes) {
                        updateMilestoneUI(milestoneDataRes.data.workstream);
                    } else {
                        console.error('No milestone data received');
                    }
                }).catch(err => {
                    console.error('Milestone data fetch error:', err);
                });

                if (response.data.action && response.data.action.is_completed === true) {
                    img.src = imgSrcFill;
                } else {
                    img.src = imgSrcEmpty;
                }
            }).catch(err => {
                console.error('Action status update error:', err);
            });
        });
    });
}

const taskListBtn = document.querySelectorAll('.js-task-item-btn');

if (taskListBtn !== null && taskListBtn !== undefined) {
    taskListBtn.forEach((item) => {
        item.addEventListener('click', () => {
            const taskItem = item.closest('.js-task-item');
            const milestoneItemId = item.closest('[data-milestone-id]').dataset.milestoneId;
            const taskItemId = taskItem.getAttribute('id');
            const sendObj = {
                workstream_id: taskItemId
            }

            const url = `/milestones/templates/${milestoneItemId}/milestone`;

            sendJSONAjax(url, sendObj, 'POST')
        });
    })
}

const btnToggleCompletion = document.querySelector('.js-toggle-completion');

if (btnToggleCompletion) {
    btnToggleCompletion.addEventListener('click', () => {
        const url = btnToggleCompletion.getAttribute('data-url');
        const errorEl = document.querySelector('.js-milestone-error');

        sendJSONAjax(url, null, 'POST').then(response => {
            if (response.errors) {
                btnToggleCompletion.classList.add('btn--gray');
                btnToggleCompletion.classList.remove('btn--blue');
                errorEl.textContent = response.message;
                errorEl.classList.remove('hidden');
            } else {
                errorEl.classList.add('hidden');
                if (response.data.milestone.is_completed) {
                    btnToggleCompletion.classList.remove('btn--gray');
                    btnToggleCompletion.classList.add('btn--blue');
                    document.querySelector('.js-milistone-container').classList.add('disabled-milistone');
                    document.querySelectorAll('.js-action-order button').forEach(btn => {
                        btn.setAttribute('disabled', true);
                    });
                } else {
                    btnToggleCompletion.classList.add('btn--gray');
                    btnToggleCompletion.classList.remove('btn--blue');
                    document.querySelector('.js-milistone-container').classList.remove('disabled-milistone');
                    document.querySelectorAll('.js-action-order button').forEach(btn => {
                        btn.removeAttribute('disabled');
                    });
                }
            }
        });
    });
}

// remove milestone
const btnSettingsRemove = document.querySelector('.js-settings-remove');
const btnRemoveMilestone = document.querySelector('.js-remove-milestone');

if (btnSettingsRemove && btnRemoveMilestone) {
    btnSettingsRemove.addEventListener('click', () => {
        const url = btnSettingsRemove.getAttribute('data-delete-url');
        btnRemoveMilestone.setAttribute('data-url', url);
    });
    btnRemoveMilestone.addEventListener('click', () => {
        const url = btnRemoveMilestone.getAttribute('data-url');

        sendJSONAjax(url, null, 'DELETE');
    });
}

function updateMilestoneProgress(completedPercent) {
    const totalSteps = 8;
    const completedSteps = Math.round((completedPercent / 100) * totalSteps);
    const progressLines = document.querySelectorAll('.progress__line');
    const percentsElement = document.querySelector('.js-percents');

    percentsElement.textContent = completedPercent;
    progressLines.forEach((line, index) => {
        if (index < completedSteps) {
            line.classList.add('progress__line--active');
        } else {
            line.classList.remove('progress__line--active');
        }
    });
}

const btnCloseEditing = document.querySelector('.js-close-editing');
if (btnCloseEditing !== null && btnCloseEditing !== undefined) {
    btnCloseEditing.addEventListener('click', () => {
        document.querySelector('.js-create-action-form').classList.add('hidden');
        document.querySelector('.js-create-action-form').reset();
        document.querySelector('.js-create-action').classList.add('hidden');
    });
}

// create new action
const createActionForm = document.querySelector('.js-create-action-form');
const milestoneAllDataUrl = createActionForm ? createActionForm.getAttribute('data-url-milestone') : null;

function updateMilestoneUI(milestoneData) {
    const milestoneTime = document.querySelector('.js-milestone-time span');
    const milestoneTimeNoCompleted = document.querySelector('.js-milestone-time-no-completed span');
    const actions = document.querySelector('.js-milestone-actions span');
    const actionsNoCompleted = document.querySelector('.js-milestone-actions-no-completed span');
    const percentsEl = document.querySelector('.js-percents');

    if (milestoneTime) milestoneTime.textContent = milestoneData.all_actions_sum_time_commitment;
    if (milestoneTimeNoCompleted) {
        const remainingTimeInHours = milestoneData.all_actions_sum_time_commitment - milestoneData.all_actions_completed_sum_time_commitment;

        if (remainingTimeInHours > 0) {
            const hours = Math.floor(remainingTimeInHours);
            const minutes = Math.round((remainingTimeInHours - hours) * 60);

            milestoneTimeNoCompleted.textContent = `${hours} Hour${hours !== 1 ? 's' : ''} ${minutes} Minute${minutes !== 1 ? 's' : ''}`;
        } else {
            milestoneTimeNoCompleted.textContent = '0 Minutes';
        }
    }
    if (actions) actions.textContent = milestoneData.all_actions_count;
    if (actionsNoCompleted) actionsNoCompleted.textContent = milestoneData.all_actions_count - milestoneData.all_actions_completed_count;
    if (percentsEl) percentsEl.textContent = milestoneData.all_actions_completed_percent;

    updateMilestoneProgress(milestoneData.all_actions_completed_percent);
}

if (createActionForm) {
    createActionForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const url = createActionForm.getAttribute('action');
        const formData = new FormData(createActionForm);

        const actionData = {};
        formData.forEach((value, key) => {
            if (key === 'time_commitment_minutes' || key === 'time_commitment_hours') {
                actionData[key] = parseInt(value, 10);
            } else {
                actionData[key] = value;
            }
        });

        sendJSONAjax(url, actionData, 'POST', false).then(response => {
            const targetBlock = document.querySelector('.js-create-action');
            const actionForm = targetBlock.querySelector('.js-create-action-form');
            const asideActionTab = document.querySelector('.js-action-tab');
            const imgSrcFill = asideActionTab.getAttribute('data-src-fill');
            const imgSrcEmpty = asideActionTab.getAttribute('data-src-empty');
            const parser = new DOMParser();
            const doc = parser.parseFromString(response, 'text/html');
            const createdActionId = doc.querySelector('.js-action-order').getAttribute('id');
            const createdActionTitle = doc.querySelector('.js-action-title').textContent;

            if (!response || response && response.includes('errors')) {
                return;
            }

            targetBlock.insertAdjacentHTML('beforebegin', response);
            createActionForm.reset();
            targetBlock.classList.add('hidden');
            actionForm.classList.add('hidden');
            sendJSONAjax(milestoneAllDataUrl, null, 'GET').then(milestoneDataRes => {
                if (milestoneDataRes) {
                    const asideListItem = `<li data-tab-target="${createdActionId}" class="tab">
                        <img width="20" height="20" class="tab__img tab__img--fill" src="${imgSrcFill}" alt="checked" />
                        <img width="20" height="20" class="tab__img" src="${imgSrcEmpty}" alt="checked" />
                        <span>${createdActionTitle}</span>
                    </li>`

                    asideActionTab.insertAdjacentHTML('beforebegin', asideListItem);
                    updateMilestoneUI(milestoneDataRes.data.milestone);
                    initCkeditor();
                }
            });
        });
    });
}

// toggle complete action
document.addEventListener('click', (e) => {
    if (e.target && e.target.matches('.js-action-completed-btn')) {
        const btn = e.target.closest('.js-action-completed-btn');

        if (!btn) return;

        const url = btn.getAttribute('data-url');
        const btnText = btn.querySelector('span');
        const completedText = btn.getAttribute('data-completed-text');
        const completeText = btn.getAttribute('data-complete-text');
        const btnImg = btn.querySelector('img');
        const imgSrcFill = btnImg.getAttribute('data-src-fill');
        const imgSrcEmpty = btnImg.getAttribute('data-src-empty');
        const parentId = btn.closest('.js-action-order').getAttribute('id');
        const asideTabItem = document.querySelector(`[data-tab-target=${parentId}]`);

        sendJSONAjax(url, null, 'POST').then(response => {
            if (!response.errors) {
                sendJSONAjax(milestoneAllDataUrl, null, 'GET').then(milestoneDataRes => {
                    if (milestoneDataRes) {
                        updateMilestoneUI(milestoneDataRes.data.milestone);
                    }
                });

                if (response.data.action.is_completed === true) {
                    btn.classList.remove('btn--gray');
                    btn.classList.add('btn--blue');
                    btnImg.src = imgSrcFill;
                    btnText.textContent = completedText;
                    asideTabItem.classList.add('tab--completed');
                } else {
                    btn.classList.remove('btn--blue');
                    btn.classList.add('btn--gray');
                    btnImg.src = imgSrcEmpty;
                    btnText.textContent = completeText;
                    asideTabItem.classList.remove('tab--completed');
                }
            }
        });
    }
})

// A function to add Unsaved Action Warning class to all links
function addUnsavedActionWarningToLinks() {
    document.querySelectorAll('a:not([target="_blank"])').forEach(e => {
        const href = e.getAttribute('href');

        if (href && !href.startsWith('#') && !e.classList.contains('js-trigger-unsaved-action-warning')) {
            e.classList.add('js-trigger-unsaved-action-warning');
        }
    });
}

function removeUnsavedActionWarningToLinks() {
    document.querySelectorAll('a:not([target="_blank"])').forEach(e => {
        const href = e.getAttribute('href');

        if (href && !href.startsWith('#')) {
            e.classList.remove('js-trigger-unsaved-action-warning');
        }
    });
}

// Displays a modal with a warning about unsaved changes and handles navigation confirmation.
function displayUnsavedChangesWarning(modalId, url, itemName) {
    const modal = document.getElementById(modalId);

    if (!modal) return;

    const modalTitle = modal.querySelector('.js-modal-title');
    const confirmLeaveBtn = modal.querySelector('.js-confirm-leave');
    const closeModalBtn = modal.querySelector('.js-close-modal');

    if (itemName) {
        modalTitle.textContent = itemName;
    }

    openModal(modalId);

    // Handle button click events
    confirmLeaveBtn.onclick = () => window.location.href = url;
    closeModalBtn.onclick = () => closeModal(modal);
}

// We show a modal if there are unsaved action changes in the editing form
document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-trigger-unsaved-action-warning');

    if (!btn) return;

    const allForms = document.querySelectorAll('.js-edit-action-form, .js-create-action-form');
    const modalId = 'modalWarningBeforeUnsavedAction';

    let isAnyFormVisible = Array.from(allForms).some((form) => {
        if (!form.classList.contains('hidden')) {
            const actionTitle = form.getAttribute('data-action-title') ?? 'New action';
            let url = btn.getAttribute('data-url') ?? btn.getAttribute('href');
            displayUnsavedChangesWarning(modalId, url, actionTitle);
            return true;
        }
        return false;
    });

    if (isAnyFormVisible) {
        e.preventDefault();
    }
});

window.addEventListener('beforeunload', function (event) {
    let isUnsaved = document.querySelector('.js-trigger-unsaved-action-warning');

    if (isUnsaved !== null) {
        window.stop();
        event.returnValue = 'sfs';
    }
    let url = this.window.location.href;
    // const actionTitle = form.getAttribute('data-action-title') ?? 'New action';
    const modalId = 'modalWarningBeforeUnsavedAction';

    // displayUnsavedChangesWarning(modalId, url, 'ssss');

})

// add action
document.addEventListener('click', (e) => {
    if (e.target && e.target.matches('.js-add-action')) {
        const btn = e.target.closest('.js-add-action');

        if (!btn) return;

        document.querySelector('.js-create-action').classList.remove('hidden');
        document.querySelector('.js-create-action-form').classList.remove('hidden');

        const target = document.querySelector($(btn).attr('href'));
        const wrapper = document.querySelector('.wrapper-content');
        const headerHeight = document.querySelector('header').offsetHeight;
        if (target) {
            setTimeout(() => {
                wrapper.scrollTo({
                    top: target.offsetTop - headerHeight,
                    behavior: 'smooth',
                    duration: 800
                });
                if (btn.closest('.settings') !== null && btn.closest('.settings') !== undefined) {
                    btn.closest('.settings').classList.remove('settings--active');
                }
            }, 0)
        }

        addUnsavedActionWarningToLinks();
    }
});

// edit action
document.addEventListener('click', (e) => {
    if (e.target && e.target.matches('.js-edit-action')) {
        const btn = e.target.closest('.js-edit-action');

        if (!btn) return;

        const parent = btn.closest('.js-action-order');
        const actionForm = parent.querySelector('.js-action-form');
        const editForm = parent.querySelector('.js-edit-action-form');
        actionForm.classList.add('hidden');
        editForm.classList.remove('hidden');

        addUnsavedActionWarningToLinks();
    }
});

// close action editing
document.addEventListener('click', (e) => {
    if (e.target && e.target.matches('.js-close-editing-action')) {
        const btn = e.target.closest('.js-close-editing-action');

        if (!btn) return;

        const parent = btn.closest('.js-action-order');
        const actionForm = parent.querySelector('.js-action-form');
        const editForm = parent.querySelector('.js-edit-action-form');
        actionForm.classList.remove('hidden');
        editForm.classList.add('hidden');
    }
});

// submit action editing
$(document).on('submit', '.js-edit-action-form', function (e) {
    e.preventDefault()

    const csrf = $('meta[name="csrf-token"]').attr('content');
    const self = $(this);
    const form = self;
    const actionForm = self.closest('.action-form').find('.js-action-form');
    const milestoneTime = document.querySelector('.js-milestone-time');
    const actions = document.querySelector('.js-milestone-actions span');
    const percentsEl = document.querySelector('.js-percents');
    const createActionForm = document.querySelector('.js-create-action-form');
    const milestoneAllDataUrl = createActionForm.getAttribute('data-url-milestone');

    const formDataObj = {
        name: self.find('[name="name"]').val(),
        time_commitment_hours: Number(self.find('[name="time_commitment_hours"]').val()),
        time_commitment_minutes: Number(self.find('[name="time_commitment_minutes"]').val()),
        description: self.find('[name="description"]').val(),
        _token: csrf
    };

    $.ajax({
        url: form.attr('action'),
        type: 'PUT',
        data: JSON.stringify(formDataObj),
        processData: false,
        contentType: false,
        headers: {
            'X-CSRF-Token': csrf,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        success: function (data) {
            const title = actionForm.find('.js-action-title');
            const description = actionForm.find('.js-action-description');
            const actionTime = actionForm.find('.js-action-time');
            const parentId = form.closest('.js-action-order').attr('id');
            const tab = $(`[data-tab-target="${parentId}"]`);

            title.text(data.data.action.name);
            description.html(data.data.action.description);
            actionTime.text(data.data.action.time_commitment_text);
            tab.find('span').text(data.data.action.name);
            tab.attr('data-tab-target', data.data.action.slug);
            self.find('.text-error').text('').addClass('hidden');
            actionForm.removeClass('hidden');
            self.addClass('hidden');

            $.ajax({
                url: milestoneAllDataUrl,
                type: 'PUT',
                data: JSON.stringify(formDataObj),
                processData: false,
                contentType: false,
                headers: {
                    'X-CSRF-Token': csrf,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                success: function (response) {
                    if (response) {
                        updateMilestoneUI(response.data.milestone);
                    }
                },
                error: function (error) {
                    if (error.errors || error.responseJSON) {
                        const textareaError = self.find('.textarea').closest('.input-holder').find('.text-error');
                        textareaError.text(error.responseJSON.message || error.errors.message).removeClass('hidden');
                    }
                }
            });
        },
        error: function (error) {
            self.find('.text-error').text('').addClass('hidden');
            if (error.responseJSON && error.responseJSON.errors) {
                const errors = error.responseJSON.errors;

                for (const fieldName in errors) {
                    if (errors.hasOwnProperty(fieldName)) {
                        const inputElement = self.find(`[name="${fieldName}"]`);
                        const errorMessage = errors[fieldName].join(', ');

                        inputElement.closest('.input-holder').find('.text-error').text(errorMessage).removeClass('hidden');
                    }
                }
            } else if (error.errors) {
                const inputElement = self.find('.textarea');
                inputElement.closest('.input-holder').find('.text-error').text(error.errors.action).removeClass('hidden');
            }
        }
    });
})


// delete action
document.addEventListener('click', (e) => {
    if (e.target && e.target.matches('.js-action-remove')) {
        const btn = e.target.closest('.js-action-remove');

        if (!btn) return;

        const url = btn.getAttribute('data-delete-url');
        const id = btn.closest('.js-action-order').getAttribute('id');
        const modalTitle = document.querySelector('.js-modal-title');
        const actionTitle = btn.closest('.js-action-order').querySelector('.js-action-title');

        btnModalRemoveAction.setAttribute('data-url', url);
        btnModalRemoveAction.setAttribute('data-block-id', id);
        modalTitle.textContent = actionTitle.textContent;
    }
});

const btnModalRemoveAction = document.querySelector('.js-modal-remove-action');
if (btnModalRemoveAction !== undefined && btnModalRemoveAction !== null) {
    btnModalRemoveAction.addEventListener('click', () => {
        const url = btnModalRemoveAction.getAttribute('data-url');
        const id = btnModalRemoveAction.getAttribute('data-block-id');

        sendJSONAjax(url, null, 'DELETE').then(() => {
            document.querySelector(`[data-tab-target="${id}"]`).remove();
            document.getElementById(id).remove();
            document.getElementById('modalRemoveAction').style.display = 'none';
            document.body.classList.remove('modal--open');

            sendJSONAjax(milestoneAllDataUrl, null, 'GET').then(milestoneDataRes => {
                if (milestoneDataRes) {
                    updateMilestoneUI(milestoneDataRes.data.milestone);
                }
            });
        });
    });
}

// create logbook
const sortLogBooksFromOldToNew = (el, items) => {
    const itemsArray = Array.from(items);

    itemsArray.sort((a, b) => {
        const dateA = new Date(a.querySelector('.js-logs-date-field').value);
        const dateB = new Date(b.querySelector('.js-logs-date-field').value);

        // sort from old to new
        return dateA - dateB;
    });
    const container = el;
    const elementsToRemove = container.querySelectorAll('.accordion:not(.js-action-logbook)');
    const target = container.querySelector('.js-action-logbook');

    // remove elements
    elementsToRemove.forEach(element => {
        container.removeChild(element);
    });

    // add new filters elements to container
    itemsArray.forEach(item => container.insertBefore(item, target));
}

document.addEventListener('click', (e) => {
    if (e.target && e.target.matches('.js-create-logbook')) {
        const btn = e.target.closest('.js-create-logbook');

        if (!btn) return;

        const parent = btn.closest('.js-action-order');
        if (!parent) return;

        const logbook = parent.querySelector('.js-action-logbook');
        if (logbook) {
            logbook.classList.remove('hidden');
        }

        addUnsavedActionWarningToLinks();
    }
});

document.addEventListener('submit', (e) => {
    if (e.target && e.target.matches('.js-create-form-logbook')) {
        e.preventDefault();
        e.stopPropagation();
        const form = e.target.closest('.js-create-form-logbook');
        if (!form) return;
        const url = form.getAttribute('action');
        const title = form.querySelector('.js-logs-title-field').value;
        const date = form.querySelector('.js-logs-date-field').value;
        const parentLogsList = form.closest('.logs');
        let html = form.querySelector('.js-ckeditor-content').value ?? '';

        const emptyContent = `<p><br data-cke-filler="true"></p>`;
        if (html.trim() === emptyContent.trim()) {
            html = '';
        }

        const formData = {
            entry_title: title,
            text: html,
            entry_date: date
        }
        sendJSONAjax(url, formData, 'POST', false).then(response => {
            if (response.errors) {
                const errors = response.errors;
                for (const fieldName in errors) {
                    if (errors.hasOwnProperty(fieldName)) {
                        if (fieldName !== 'text') {
                            const inputElement = form.querySelector(`[name="${fieldName}"]`);
                            const errorMessage = errors[fieldName].join(', ');
                            const errorEl = inputElement.closest('.input-error').querySelector('.text-error');

                            errorEl.textContent = errorMessage;
                            errorEl.classList.remove('hidden');
                        } else {
                            form.querySelector('.js-editor-error').textContent = errors.text;
                            form.querySelector('.js-editor-error').classList.remove('hidden');
                        }
                    }
                }
            } else {
                form.closest('.js-action-logbook').classList.add('hidden');
                form.reset();
                editor.setData('');
                form.querySelectorAll('.text-error').forEach((text) => {
                    text.classList.add('hidden');
                });
                form.closest('.js-action-logbook').insertAdjacentHTML('beforebegin', response);
                initCkeditor();
                sortLogBooksFromOldToNew(parentLogsList, parentLogsList.querySelectorAll('.accordion:not(.js-action-logbook)'));
            }
        });
    }
});

// close logbook creating
document.addEventListener('click', (e) => {
    if (e.target && e.target.matches('.js-close-logbook')) {
        const btn = e.target.closest('.js-close-logbook');
        if (!btn) return;

        const parent = btn.closest('.js-action-order');
        if (!parent) return;

        const logbook = parent.querySelector('.js-action-logbook');
        if (logbook) {
            logbook.classList.add('hidden');
        }

        removeUnsavedActionWarningToLinks();
    }
});

// update logbook
if (document.querySelectorAll('.logs__accordion').length) {
    document.addEventListener('click', (e) => {
        const accordion = e.target.closest('.logs__accordion');

        if (accordion) {
            if (accordion.classList.contains('accordion--open')) return;
        } else {
            const openAccordion = document.querySelector('.js__accordion.accordion--open');
            if (openAccordion) {
                const parent = openAccordion.closest('.js-action-order');
                const form = parent.querySelector('.js-create-form-logbook');
                const url = form.getAttribute('action');
                const titleEl = openAccordion.querySelector('.js-logs-title');
                const dateEl = openAccordion.querySelector('.js-logs-time');
                const title = openAccordion.querySelector('.js-logs-title-field').value;
                const date = openAccordion.querySelector('.js-logs-date-field').value;
                const logbookId = openAccordion.querySelector('.logs__info').getAttribute('id');
                const accordionBtn = openAccordion.querySelector('.accordion__btn');
                const editorElement = openAccordion.querySelector('.js-ckeditor-content');
                const content = openAccordion.querySelector('.ck-editor__editable');
                const editor = editorInstances[editorElement];
                let html = editor ? editor.getData() : content.innerHTML;

                const emptyContent = `<p><br data-cke-filler="true"></p>`;
                if (html.trim() === emptyContent.trim()) {
                    html = '';
                }

                const formData = {
                    entry_title: title,
                    text: html,
                    entry_date: date
                }
                sendJSONAjax(url + `/${logbookId}`, formData, 'PUT').then(response => {
                    if (response.errors) {
                        const errors = response.errors;
                        for (const fieldName in errors) {
                            if (errors.hasOwnProperty(fieldName)) {
                                if (fieldName !== 'text') {
                                    const inputElement = openAccordion.querySelector(`[name="${fieldName}"]`);
                                    const errorMessage = errors[fieldName].join(', ');
                                    const errorEl = inputElement.closest('.input-error').querySelector('.text-error');

                                    errorEl.textContent = errorMessage;
                                    errorEl.classList.remove('hidden');
                                } else {
                                    openAccordion.querySelector('.js-editor-error').textContent = errors.text;
                                    openAccordion.querySelector('.js-editor-error').classList.remove('hidden');
                                }
                            }
                        }
                    } else {
                        titleEl.textContent = response.data.logbook_entry.entry_title;
                        dateEl.textContent = response.data.logbook_entry.entry_date_formatted;
                        openAccordion.querySelectorAll('.text-error').forEach((text) => {
                            text.classList.add('hidden');
                        });
                        // accordionBtn.click(); 
                        sortLogBooksFromOldToNew(openAccordion.closest('.logs'), openAccordion.closest('.logs').querySelectorAll('.accordion:not(.js-action-logbook)'));
                    }
                });
            }
        }
    });
}

(function initDiagnosticShowAll(){
  if(typeof document==='undefined')return;
  var list=document.querySelector('[data-diagnostic-list]');
  if(!list)return;
  var visibleCount=parseInt(list.getAttribute('data-visible-count')||'5',10);
  var triggers=Array.prototype.slice.call(document.querySelectorAll('[data-diagnostic-toggle]'));
  if(!triggers.length)return;
  var collapsedText=list.getAttribute('data-collapsed-text')||'Show all';
  var expandedText=list.getAttribute('data-expanded-text')||'Show less';

  function setTriggerText(trigger, text){
    var span=trigger.querySelector('[data-diagnostic-toggle-text]');
    if(span){ span.textContent=text; }
    else { trigger.textContent=text; }
  }

  function updateState(expanded){
    var items=list.querySelectorAll('.js-diagnostic-item');
    items.forEach(function(el,idx){
      if(!expanded&&idx>=visibleCount){
        el.classList.add('is-hidden');
      }else{
        el.classList.remove('is-hidden');
      }
    });
    triggers.forEach(function(t){
      t.setAttribute('aria-expanded',String(expanded));
      setTriggerText(t, expanded?expandedText:collapsedText);
    });
    list.classList.toggle('is-collapsed',!expanded);
    list.classList.toggle('is-expanded',expanded);
  }

  triggers.forEach(function(t){
    t.addEventListener('click',function(e){
      e.preventDefault();
      var expanded=t.getAttribute('aria-expanded')==='true';
      updateState(!expanded);
    });
  });

  updateState(false);
})();
